import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/style/style.scss';

import { DataProvider } from './context/DataContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import LeaderboardPage from './pages/LeaderboardPage';
import CategoryStatsPage from './pages/CategoryStatsPage';
import FicheDecode from './pages/FicheDecode';

const App = () => {
  return (
    <DataProvider>
      <div className="container-fluid p-0">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recherche" element={<SearchPage />} />
          <Route path="/classement" element={<LeaderboardPage />} />
          <Route path="/stats-categorie" element={<CategoryStatsPage />} />
          <Route path="/fiche-de-note" element={<FicheDecode />} />
        </Routes>
      </div>
    </DataProvider>
  );
};

export default App;
